import './index.css'

import React from 'react'
import { connect } from 'react-redux'

import { openFolder } from '@disco/state-management/actions/ExplorerActions'

import type { Group } from 'types/group'

import GroupItemActions from 'components/ellipsis-menus/group-item-actions'
import GroupContextMenu from 'components/ellipsis-menus/group-item-actions/group-context-menu'
import { HoverProvider } from 'components/ui/hover-provider'
import Icon from 'components/ui/icon'
import MediaItem from 'components/ui/media-item'
import PaneItem from 'components/ui/pane-item'

type OwnProps = {
  appearance: 'default' | 'disabled' | 'active' | 'selected' | 'player'
  group: Group
  pane: Record<string, any>
  hideActions?: boolean
  disableHandlers?: boolean
  isOver?: boolean
  index: number
  isSubfolder: boolean
}
type StateProps = {
  openFolder: typeof openFolder
}
type Props = OwnProps & StateProps
type State = {
  showRenameDialog: boolean
  showDeleteDialog: boolean
}

class ExplorerFolder extends React.Component<Props, State> {
  _handleClick = e => {
    if (this.props.disableHandlers) return
    // folders doesn't allow selection
    if (e.metaKey || e.ctrlKey || e.shiftKey) return
    // @ts-expect-error
    this.props.openFolder(this.props.pane, this.props.index, this.props.group)
  }

  _renderActions() {
    if (this.props.hideActions) return null
    return (
      <GroupItemActions
        compact
        group={this.props.group}
        groupDepth={this.props.isSubfolder ? 2 : 1}
      />
    )
  }

  render() {
    const { appearance, group, isSubfolder } = this.props
    return (
      <HoverProvider enableTouchSupport>
        <GroupContextMenu group={group} groupDepth={isSubfolder ? 2 : 1}>
          <PaneItem
            appearance={appearance}
            content={
              <MediaItem
                media={
                  <div className="ExplorerFolder_Artwork">
                    <Icon type="folder" />
                  </div>
                }
                title={group.name}
                caption="Folder"
              />
            }
            actions={this._renderActions()}
            onClick={this._handleClick}
          />
        </GroupContextMenu>
      </HoverProvider>
    )
  }
}

export default connect(null, {
  openFolder,
})(ExplorerFolder) as any
